import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import ConfirmDialog from '@common/ui/ConfirmDialog';

interface InvalidateActionProps {
  loading?: boolean;
  buttonText?: string;
  confirmText?: string;
  invalidateAction: () => void;
  variant?: 'contained' | 'outlined';
}

export default function InvalidateAction({
  loading,
  buttonText,
  confirmText,
  invalidateAction,
  variant = 'contained',
}: InvalidateActionProps) {
  const [opened, setOpened] = useState(false);

  return (
    <div>
      <LoadingButton
        data-trigger={`User Clicked ${buttonText} Button`}
        variant={variant}
        size="small"
        loading={loading}
        onClick={() => setOpened(true)}
      >
        {buttonText || 'Invalidate'}
      </LoadingButton>
      <ConfirmDialog open={opened} onClose={() => setOpened(false)} onConfirm={invalidateAction}>
        {confirmText || `Are you sure you want to invalidate?`}
      </ConfirmDialog>
    </div>
  );
}
